var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0593 1.45601C9.8991 1.34376 8.70411 1.28516 7.48358 1.28516C6.26305 1.28516 5.06805 1.34376 3.90787 1.45601C2.63122 1.57953 1.65457 2.87351 1.5969 4.4491C1.50784 6.88252 1.46094 9.40863 1.46094 11.9994C1.46094 14.5902 1.50784 17.1164 1.5969 19.5498C1.65457 21.1254 2.63122 22.4194 3.90787 22.5429C5.06805 22.6551 6.26305 22.7137 7.48358 22.7137C8.70411 22.7137 9.8991 22.6551 11.0593 22.5429C12.3359 22.4194 13.3126 21.1254 13.3702 19.5498C13.402 18.6816 13.4284 17.8015 13.4493 16.911V7.08794C13.4284 6.19737 13.402 5.31734 13.3702 4.4491C13.3126 2.87351 12.3359 1.57952 11.0593 1.45601Z",
    fill: "#501713"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6747 12.1557C15.6747 13.0055 15.7938 14.2018 15.9166 15.2097C16.0417 16.2371 17.0696 16.8951 18.017 16.4786C19.7513 15.7161 21.3498 14.5851 22.4686 12.9402C22.7908 12.4664 22.7909 11.845 22.4686 11.3712C21.3499 9.72626 19.7514 8.59524 18.0171 7.83282C17.0697 7.41635 16.0419 8.07431 15.9167 9.10158C15.7938 10.1096 15.6747 11.3059 15.6747 12.1557Z",
    fill: "#501713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6747 12.1557C15.6747 13.0055 15.7938 14.2018 15.9166 15.2097C16.0417 16.2371 17.0696 16.8951 18.017 16.4786C19.7513 15.7161 21.3498 14.5851 22.4686 12.9402C22.7908 12.4664 22.7909 11.845 22.4686 11.3712C21.3499 9.72626 19.7514 8.59524 18.0171 7.83282C17.0697 7.41635 16.0419 8.07431 15.9167 9.10158C15.7938 10.1096 15.6747 11.3059 15.6747 12.1557Z",
    stroke: "#F04438",
    strokeWidth: 2.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3702 4.4491C13.3126 2.87351 12.3359 1.57952 11.0593 1.45601C9.8991 1.34376 8.70411 1.28516 7.48358 1.28516C6.26305 1.28516 5.06805 1.34376 3.90787 1.45601C2.63122 1.57953 1.65457 2.87351 1.5969 4.4491C1.50784 6.88252 1.46094 9.40863 1.46094 11.9994C1.46094 14.5902 1.50784 17.1164 1.5969 19.5498C1.65457 21.1254 2.63122 22.4194 3.90787 22.5429C5.06805 22.6551 6.26305 22.7137 7.48358 22.7137C8.70411 22.7137 9.8991 22.6551 11.0593 22.5429C12.3359 22.4194 13.3126 21.1254 13.3702 19.5498",
    stroke: "#F04438",
    strokeWidth: 2.57143,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86376 12.1543L15.6699 12.1543",
    stroke: "#F04438",
    strokeWidth: 2.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLogout);
export default __webpack_public_path__ + "static/media/arrow-right-logout.6c7c4916d163f29d63937825425e75b3.svg";
export { ForwardRef as ReactComponent };